import { ITEMS_PER_PAGE } from '@/modules/accredited-establishments/constants/'

interface GetNextPageParamProps {
  totalOfItems: number
  totalOfCurrentPages: number
}

/**
 * Calculates pagination parameters for the next page. *
 *
 * The range is calculated using the `ITEMS_PER_PAGE` constant and follows an inclusive format: `[start, end]`.
 *
 * @param {Object} params - Parameters required for the calculation.
 * @param {number} params.totalOfItems - The total number of available items.
 * @param {number} params.totalOfCurrentPages - The number of pages currently loaded.
 *
 * @returns {[number, number] | null} A tuple containing the start and end indices of the next page, or `null` if there are no more pages.
 *
 */
const getNextPageParam = ({
  totalOfItems,
  totalOfCurrentPages
}: GetNextPageParamProps): [number, number] | null => {
  const hasNextPage = totalOfItems / ITEMS_PER_PAGE > totalOfCurrentPages

  if (hasNextPage) {
    const start = totalOfCurrentPages * ITEMS_PER_PAGE
    const end = start + ITEMS_PER_PAGE - 1
    return [start, end]
  }

  return null
}

export { getNextPageParam }
